(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function (event) {
    if (document.querySelector('.warenkorb_off')) {
      document.querySelector('.template-index').classList.add('cart_deactivated');
    }
  });
  // Triggered Slider
  {
    document.querySelectorAll("[data-triggered-slider='wrapper']").forEach((wrapper) => {
      wrapper.trigger = Array.from(wrapper.querySelector("[data-triggered-slider='trigger']").children);
      wrapper.slider = wrapper.querySelectorAll("[data-triggered-slider='slider']");
      wrapper.resetTrigger = () => {
        wrapper.trigger.forEach((elem) => {
          elem.classList.remove('trigger--active');
        });
      };
      wrapper.trigger.forEach((trigger) => {
        const n = Array.prototype.indexOf.call(wrapper.trigger, trigger) + 1;
        trigger.addEventListener('click', function () {
          wrapper.resetTrigger();
          this.classList.add('trigger--active');
          wrapper.slider.forEach((slider) => {
            slider.querySelector('.w-slider-dot:nth-child(' + n + ')').click();
          });
        });
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (event) => {
    // slider
    const testimonialSlider = new Slider({
      wrapper: document.querySelector('.testimonials.slider'),
    });
  });

  } catch(e) { console.error(e); }
})();
})();
